import React, { useContext, useEffect, useState } from "react";
import { Form, Input, Button, message } from "antd";
import styled from "styled-components";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { loginAPI } from "../api/authAPI";
import useAuth from "../hook/auth";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  margin: 0 auto;
  width: 60vw;
  height: 85vh;
  padding: 20px;
  display: flex;
  align-items: center;
`;

const FormContainer = styled.div`
  margin: 0 auto;
  width: 50vw;
  padding: 20px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #ddd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

const FormTitle = styled.h1`
  text-align: center;
  margin-bottom: 20px;
`;

const FormButtonWrapper = styled.div`
  margin-top: 50px;
  display: flex;
  justify-content: center;
`;

const StyledInput = styled(Input)`
  width: 100%;
`;

const LoginPage = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));

  const navigate = useNavigate();

  const handleSubmit = async () => {
    const user = await loginAPI(username, password);
    if (user) {
      message.success("Login successful! Redirecting to the homepage...");
      setTimeout(() => navigate("/"), 2000);
    } else {
      message.error(
        "Login failed! Please check your credentials and try again."
      );
    }
  };

  useEffect(() => {
    if (user) {
      navigate("/");
    }
  }, [user, navigate]);

  return (
    <Container>
      <FormContainer>
        <FormTitle>Login</FormTitle>
        <Form onFinish={handleSubmit}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: "Please enter your username" }]}
          >
            <StyledInput
              prefix={<UserOutlined />}
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[{ required: true, message: "Please enter your password" }]}
          >
            <StyledInput.Password
              prefix={<LockOutlined />}
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </Form.Item>
          <Form.Item>
            <FormButtonWrapper>
              <Button type="primary" htmlType="submit">
                Login
              </Button>
            </FormButtonWrapper>
          </Form.Item>
        </Form>
      </FormContainer>
    </Container>
  );
};

export default LoginPage;
